import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=7a7b290a&scoped=true"
import script from "./RoleList.vue?vue&type=script&lang=js"
export * from "./RoleList.vue?vue&type=script&lang=js"
import style0 from "./RoleList.vue?vue&type=style&index=0&id=7a7b290a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7b290a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a7b290a')) {
      api.createRecord('7a7b290a', component.options)
    } else {
      api.reload('7a7b290a', component.options)
    }
    module.hot.accept("./RoleList.vue?vue&type=template&id=7a7b290a&scoped=true", function () {
      api.rerender('7a7b290a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/RoleList.vue"
export default component.exports